// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
}
body {
  background-color: rgba(255, 255, 255, 0.95);
  color: #fbfbfb;
}
.loginWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #234099;
}
/* .loginWrapper::before {content:"";position: absolute;top: 0;left: 0; width: 100%; height: 100%;    background-color: rgba(0, 0, 0, 0.3);} */
.loginContainerParent {
  width: 40%;
  max-width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 20px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 30px;
}
.loginHeader {
  position: relative;
  width: 100%;
  margin-bottom: 35px;
  display: none;
}
.loginHeader a {
  display: inline-block;
  max-width: 150px;
}
.loginHeader a img {
  width: 100%;
  height: auto;
  vertical-align: top;
}
.loginContent {
  position: relative;
  width: 100%;
}
h1 {
  font-family: 'montserratregular', helvetica, sans-serif;
  font-size: 2.1rem;
  margin-top: 0;
  margin-bottom: 15px;
  line-height: normal;
  color: #3b4048;
  text-transform: unset;
}
.loginContent > p {
  color: #989898;
  margin-bottom: 20px;
  font-size: 1rem;
}

.cbLink {
  display: flex;
  justify-content: space-between;
}
.cbLink a {
  color: #055eab;
  font-family: 'montserratregular', helvetica, sans-serif;
}
.cbLink a:hover {
  color: #045091;
}
.cbLink label {
  font-family: 'montserratregular', helvetica, sans-serif;
  font-size: 1rem;
  color: #231f20;
  margin-bottom: 0;
}
.btn_submit {
  font-size: 1.2rem !important;
  min-width: 115px;
  height: 40px;
}
/* .form-group.vError .form-control {border-color: #ff0000;} */
.errorText {
  position: absolute;
  top: 12px;
  right: 20px;
  color: #ff0000;
  font-size: 0.85rem;
  font-style: italic;
  display: none;
}
.vError .errorText {
  display: block;
}

.loginFooter {
  margin-top: auto;
}
.loginFooter > p {
  margin-bottom: 0;
  color: #939598;
  font-size: 0.9rem;
}
.loginFooter > p > a {
  max-width: 61px;
  margin-left: 5px;
  display: inline-block;
}
.loginFooter > p > a > img {
  width: 100%;
  height: auto;
  vertical-align: middle;
}
.lCheckbox {
  position: relative;
  padding-left: 5px;
}
input[type='checkbox'] {
  margin: 0;
  opacity: 0;
}
.lCheckbox input[type='checkbox'] + span {
  font-size: 1.5rem;
  color: #939598;
}
.lCheckbox input[type='checkbox'] + span:before {
  content: '\\f372';
  position: relative;
  display: inline-block;
  font-family: 'Ionicons';
  font-style: normal;
  font-weight: normal;
  transform: translate(0, 0);
  text-rendering: auto;
  /* speak: none; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.lCheckbox input[type='checkbox']:checked + span:before {
  content: '\\f373';
  position: relative;
  color: #055eab;
  display: inline-block;
  font-family: 'Ionicons';
  font-style: normal;
  font-weight: normal;
  transform: translate(0, 0);
  text-rendering: auto;
  /* speak: none; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}

.helpModal a {
  color: #055eab;
}
.helpModal a:hover {
  color: #000;
}
.helpModal p span {
  font-family: 'montserratregular', helvetica, sans-serif;
}

.fBox span.iconEye {
  color: #055daa;
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  right: 15px;
  line-height: normal;
  cursor: pointer;
  display: none;
}

.selectGrp:after {
  right: 15px;
}

.header {
  padding-left: 15px;
}
.loginWrapper .header .btnLeftNav {
  display: none;
}
.selectGrp .form-control:focus {
  box-shadow: none;
  border-color: #000;
}

@media only screen and (max-width: 768px) {
  .logoContainer {
    display: none;
  }
  .loginContainerParent {
    width: 80%;
  }
  .loginHeader {
    display: block;
  }
}
.form-group {
  position: relative;
  margin-bottom: 20px !important;
}

label,
.label {
  color: #8f9bb3;
  font-size: 0.85rem;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  white-space: normal;
  margin-bottom: 5px;
}
.form-control {
  padding: 5px 8px !important;
  background-color: #f7f9fc;
  /* border-color: #e4e9f2; */
  border-color: #8f9bb3;
  color: #222b45;
  height: 38px !important;
}
.header {
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  z-index: 99;
  background-color: transparent;
  box-shadow: none;
}

.header .headerActions {
  margin-left: auto;
}
@media only screen and (max-width: 576px) {
  .header .logo {
    display: none;
  }
}

/* CSS for New login screen starts here */
.carousel-item h1 {
  color: #fff;
  font-size: 20px;
  margin: 75px auto;
  text-align: center;
}
.login-block {
  width: 100%;
  margin: 0 auto;
  height: 100vh;
}
.signup__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.login_sec {
  padding: 0px;
  background-color: #f8fafb;
}
.login_sec img {
  margin: 24px auto;
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}

.carousel-indicators {
  bottom: -41px;
}

.carousel-indicators .active {
  background-color: #fff;
}

.container {
  box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);
  border-radius: 0.375rem;
  margin-bottom: 5%;
}

.carousel-inner {
  border-radius: 0 10px 10px 0;
}

.carousel-caption {
  text-align: left;
  left: 5%;
}

.login-sec {
  padding: 0px 0px 50px 0px;
  position: relative;
  background-color: #f5f5f5;
  height: 100vh;
}

.login-sec h2 {
  margin-bottom: 5px;
  font-weight: 800;
  font-size: 30px;
  color: black;
}

.login-sec h2:after {
  content: ' ';
  width: 100px;
  height: 5px;
  background: vilotecolor;
  display: block;
  margin-top: 8px;
  border-radius: 3px;
  margin-left: auto;
  margin-right: auto;
}

.banner-text {
  width: 70%;
  position: absolute;
  bottom: 40px;
  padding-left: 20px;
}

.banner-text h2 {
  color: #fff;
  font-weight: 600;
}

.banner-text h2:after {
  content: ' ';
  width: 100px;
  height: 5px;
  background: #fff;
  display: block;
  margin-top: 20px;
  border-radius: 3px;
}

.banner-text p {
  color: #fff;
}

.container-login-form-btn {
  padding-top: 1%;
  padding-bottom: 2%;
}

.login-form {
  width: 100%;
}

.validate-input {
  position: relative;
}

.wrap-input {
  width: 100%;
  position: relative;
  margin-bottom: 5%;
}

.label-input {
  font-size: 14px;
  color: #8d8d8d;
  line-height: 1.5;
  padding-left: 3px;
}

textarea:focus,
input:focus {
  border-color: transparent !important;
}

.input:focus + .focus-input::before {
  width: 100%;
}

.input {
  font-size: 13px;
  color: #333333;
  line-height: 1.2;
  display: block;
  width: 100%;
  height: 38px;
  padding: 5px 8px;
}

.focus-input {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}

.flex-c-m {
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}

.login-container {
  position: relative;
  left: 62%;
  top: 47%;
  border-radius: 20px;
  transform: translate(-50%, -50%);
  background-color: #f5f5f5;
  padding: 5px 30px 30px 30px;
}

.login-form-container {
  width: 65%;
  align-items: center;
  position: relative;
  left: 4%;
  top: 1rem;
  border-radius: 20px;
  padding: 12px 5px 30px 5px;
}

.login-container p {
  color: #989898;
  margin-bottom: 20px;
  font-size: 1rem;
}

.login-btn {
  font-weight: bold;
  /* background-color: #0d549b; */
  /* border-color: #0d549b; */
}

.login-btn:hover {
  background-color: #bcd239;
  border-color: #bcd239;
  box-shadow: 0px 8px 12px rgba(204, 204, 204, 0.4);
}

.banner-sec {
  background-image: url(/assets/theme/images/company/symbiosys-bg-logo.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
}

.asterisk {
  color: red;
}

.login-sec .navbar {
  justify-content: end;
  padding-bottom: 0;
  background-color: #ffc107 !important;
}

.login-sec .navbar-brand {
  padding-bottom: 0px;
}

.navbar-brand img {
  width: 200px;
}

.form-control:focus {
  box-shadow: 0 0 0 0.1rem rgba(188, 210, 57, 0.35);
}

.login-container select {
  font-size: 13px;
  color: #333333;
  line-height: 1.2;
  display: block;
  width: 100%;
  height: 38px !important;
  padding: 5px 8px;
}

.custom-select:focus {
  border-color: transparent;
}

.banner {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.carousel-container h5 {
  color: white;
  text-wrap-mode: nowrap;
  margin-bottom: 20%;
  margin-top: 5px;
}

@media (max-width: 575px) {
  .login-container {
    padding: 30px;
    width: 85%;
    border: 1px solid #0b3870;
    left: 50%;
  }

  .login-sec {
    padding: 0;
    background-color: #0b3870;
  }

  .company-logo {
    display: none;
  }

  .banner-sec {
    display: none;
  }

  .navbar-brand img {
    width: 140px;
    margin-bottom: 30px;
  }

  .navbar-brand {
    margin: 0;
  }

  .navbar {
    padding: 0;
  }

  .login-form-container {
    width: 100%;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .login-container {
    padding: 30px;
    width: 85%;
    border: 1px solid #0b3870;
  }

  .login-form {
    padding: 0;
  }

  .login-sec {
    padding: 10px 5px 50px 5px;
  }

  .carousel-container img {
    width: 70px;
  }
  .carcarousel-container h5 {
    font-size: 1rem;
  }
  .navbar-brand img {
    width: 150px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .login-container {
    padding: 5px 5px 30px 5px;
  }

  .login-form {
    padding: 5px 5px 30px 5px;
  }

  .login-sec {
    padding: 10px 5px 50px 5px;
  }

  .carousel-container h5 {
    text-wrap-mode: wrap;
  }

  .login-form-container {
    left: 0%;
    width: 83%;
  }
}

@media (min-width: 576px) {
  .mobCompany-logo {
    display: none;
  }
}

.carousel-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  gap: 13%;
  flex-wrap: wrap;
}

select {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
}

select:focus {
  background-image: linear-gradient(45deg, #333 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, #333 50%);
  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  padding: 8px 16px 5px 6px;
  border-radius: 0.295em;
  outline: 0;
}

.carousel-container img {
  width: 75px;
  border: 2px solid #fff;
  padding: 15px;
}
/* CSS for New login screen ends here */
`, "",{"version":3,"sources":["webpack://./src/app/system-common/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA,8IAA8I;AAC9I;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,uDAAuD;EACvD,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,uDAAuD;AACzD;AACA;EACE,cAAc;AAChB;AACA;EACE,uDAAuD;EACvD,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;AACA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EAInB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EAInB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,iDAAiD;EACjD,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;;AAEA;EAKE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,yEAAyE;EACzE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;IACb,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE;sDACoD;EACpD,wFAAwF;EACxF,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;sDACoD;EACpD,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;AACA,uCAAuC","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\nhtml,\nbody {\n  height: 100%;\n}\nbody {\n  background-color: rgba(255, 255, 255, 0.95);\n  color: #fbfbfb;\n}\n.loginWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #234099;\n}\n/* .loginWrapper::before {content:\"\";position: absolute;top: 0;left: 0; width: 100%; height: 100%;    background-color: rgba(0, 0, 0, 0.3);} */\n.loginContainerParent {\n  width: 40%;\n  max-width: 400px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 20px;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  padding: 30px;\n}\n.loginHeader {\n  position: relative;\n  width: 100%;\n  margin-bottom: 35px;\n  display: none;\n}\n.loginHeader a {\n  display: inline-block;\n  max-width: 150px;\n}\n.loginHeader a img {\n  width: 100%;\n  height: auto;\n  vertical-align: top;\n}\n.loginContent {\n  position: relative;\n  width: 100%;\n}\nh1 {\n  font-family: 'montserratregular', helvetica, sans-serif;\n  font-size: 2.1rem;\n  margin-top: 0;\n  margin-bottom: 15px;\n  line-height: normal;\n  color: #3b4048;\n  text-transform: unset;\n}\n.loginContent > p {\n  color: #989898;\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\n\n.cbLink {\n  display: flex;\n  justify-content: space-between;\n}\n.cbLink a {\n  color: #055eab;\n  font-family: 'montserratregular', helvetica, sans-serif;\n}\n.cbLink a:hover {\n  color: #045091;\n}\n.cbLink label {\n  font-family: 'montserratregular', helvetica, sans-serif;\n  font-size: 1rem;\n  color: #231f20;\n  margin-bottom: 0;\n}\n.btn_submit {\n  font-size: 1.2rem !important;\n  min-width: 115px;\n  height: 40px;\n}\n/* .form-group.vError .form-control {border-color: #ff0000;} */\n.errorText {\n  position: absolute;\n  top: 12px;\n  right: 20px;\n  color: #ff0000;\n  font-size: 0.85rem;\n  font-style: italic;\n  display: none;\n}\n.vError .errorText {\n  display: block;\n}\n\n.loginFooter {\n  margin-top: auto;\n}\n.loginFooter > p {\n  margin-bottom: 0;\n  color: #939598;\n  font-size: 0.9rem;\n}\n.loginFooter > p > a {\n  max-width: 61px;\n  margin-left: 5px;\n  display: inline-block;\n}\n.loginFooter > p > a > img {\n  width: 100%;\n  height: auto;\n  vertical-align: middle;\n}\n.lCheckbox {\n  position: relative;\n  padding-left: 5px;\n}\ninput[type='checkbox'] {\n  margin: 0;\n  opacity: 0;\n}\n.lCheckbox input[type='checkbox'] + span {\n  font-size: 1.5rem;\n  color: #939598;\n}\n.lCheckbox input[type='checkbox'] + span:before {\n  content: '\\f372';\n  position: relative;\n  display: inline-block;\n  font-family: 'Ionicons';\n  font-style: normal;\n  font-weight: normal;\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n  text-rendering: auto;\n  /* speak: none; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n}\n.lCheckbox input[type='checkbox']:checked + span:before {\n  content: '\\f373';\n  position: relative;\n  color: #055eab;\n  display: inline-block;\n  font-family: 'Ionicons';\n  font-style: normal;\n  font-weight: normal;\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n  text-rendering: auto;\n  /* speak: none; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n}\n\n.helpModal a {\n  color: #055eab;\n}\n.helpModal a:hover {\n  color: #000;\n}\n.helpModal p span {\n  font-family: 'montserratregular', helvetica, sans-serif;\n}\n\n.fBox span.iconEye {\n  color: #055daa;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%);\n  right: 15px;\n  line-height: normal;\n  cursor: pointer;\n  display: none;\n}\n\n.selectGrp:after {\n  right: 15px;\n}\n\n.header {\n  padding-left: 15px;\n}\n.loginWrapper .header .btnLeftNav {\n  display: none;\n}\n.selectGrp .form-control:focus {\n  box-shadow: none;\n  border-color: #000;\n}\n\n@media only screen and (max-width: 768px) {\n  .logoContainer {\n    display: none;\n  }\n  .loginContainerParent {\n    width: 80%;\n  }\n  .loginHeader {\n    display: block;\n  }\n}\n.form-group {\n  position: relative;\n  margin-bottom: 20px !important;\n}\n\nlabel,\n.label {\n  color: #8f9bb3;\n  font-size: 0.85rem;\n  position: relative;\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\n  white-space: normal;\n  margin-bottom: 5px;\n}\n.form-control {\n  padding: 5px 8px !important;\n  background-color: #f7f9fc;\n  /* border-color: #e4e9f2; */\n  border-color: #8f9bb3;\n  color: #222b45;\n  height: 38px !important;\n}\n.header {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  z-index: 99;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.header .headerActions {\n  margin-left: auto;\n}\n@media only screen and (max-width: 576px) {\n  .header .logo {\n    display: none;\n  }\n}\n\n/* CSS for New login screen starts here */\n.carousel-item h1 {\n  color: #fff;\n  font-size: 20px;\n  margin: 75px auto;\n  text-align: center;\n}\n.login-block {\n  width: 100%;\n  margin: 0 auto;\n  height: 100vh;\n}\n.signup__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.login_sec {\n  padding: 0px;\n  background-color: #f8fafb;\n}\n.login_sec img {\n  margin: 24px auto;\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-duration: 0.6s;\n  transition-property: opacity;\n}\n\n.carousel-indicators {\n  bottom: -41px;\n}\n\n.carousel-indicators .active {\n  background-color: #fff;\n}\n\n.container {\n  -webkit-box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);\n  border-radius: 0.375rem;\n  margin-bottom: 5%;\n}\n\n.carousel-inner {\n  border-radius: 0 10px 10px 0;\n}\n\n.carousel-caption {\n  text-align: left;\n  left: 5%;\n}\n\n.login-sec {\n  padding: 0px 0px 50px 0px;\n  position: relative;\n  background-color: #f5f5f5;\n  height: 100vh;\n}\n\n.login-sec h2 {\n  margin-bottom: 5px;\n  font-weight: 800;\n  font-size: 30px;\n  color: black;\n}\n\n.login-sec h2:after {\n  content: ' ';\n  width: 100px;\n  height: 5px;\n  background: vilotecolor;\n  display: block;\n  margin-top: 8px;\n  border-radius: 3px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.banner-text {\n  width: 70%;\n  position: absolute;\n  bottom: 40px;\n  padding-left: 20px;\n}\n\n.banner-text h2 {\n  color: #fff;\n  font-weight: 600;\n}\n\n.banner-text h2:after {\n  content: ' ';\n  width: 100px;\n  height: 5px;\n  background: #fff;\n  display: block;\n  margin-top: 20px;\n  border-radius: 3px;\n}\n\n.banner-text p {\n  color: #fff;\n}\n\n.container-login-form-btn {\n  padding-top: 1%;\n  padding-bottom: 2%;\n}\n\n.login-form {\n  width: 100%;\n}\n\n.validate-input {\n  position: relative;\n}\n\n.wrap-input {\n  width: 100%;\n  position: relative;\n  margin-bottom: 5%;\n}\n\n.label-input {\n  font-size: 14px;\n  color: #8d8d8d;\n  line-height: 1.5;\n  padding-left: 3px;\n}\n\ntextarea:focus,\ninput:focus {\n  border-color: transparent !important;\n}\n\n.input:focus + .focus-input::before {\n  width: 100%;\n}\n\n.input {\n  font-size: 13px;\n  color: #333333;\n  line-height: 1.2;\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 5px 8px;\n}\n\n.focus-input {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.flex-c-m {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  -ms-align-items: center;\n  align-items: center;\n}\n\n.login-container {\n  position: relative;\n  left: 62%;\n  top: 47%;\n  border-radius: 20px;\n  transform: translate(-50%, -50%);\n  background-color: #f5f5f5;\n  padding: 5px 30px 30px 30px;\n}\n\n.login-form-container {\n  width: 65%;\n  align-items: center;\n  position: relative;\n  left: 4%;\n  top: 1rem;\n  border-radius: 20px;\n  padding: 12px 5px 30px 5px;\n}\n\n.login-container p {\n  color: #989898;\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\n\n.login-btn {\n  font-weight: bold;\n  /* background-color: #0d549b; */\n  /* border-color: #0d549b; */\n}\n\n.login-btn:hover {\n  background-color: #bcd239;\n  border-color: #bcd239;\n  box-shadow: 0px 8px 12px rgba(204, 204, 204, 0.4);\n}\n\n.banner-sec {\n  background-image: url(/assets/theme/images/company/symbiosys-bg-logo.jpg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  height: 100vh;\n}\n\n.asterisk {\n  color: red;\n}\n\n.login-sec .navbar {\n  justify-content: end;\n  padding-bottom: 0;\n  background-color: #ffc107 !important;\n}\n\n.login-sec .navbar-brand {\n  padding-bottom: 0px;\n}\n\n.navbar-brand img {\n  width: 200px;\n}\n\n.form-control:focus {\n  box-shadow: 0 0 0 0.1rem rgba(188, 210, 57, 0.35);\n}\n\n.login-container select {\n  font-size: 13px;\n  color: #333333;\n  line-height: 1.2;\n  display: block;\n  width: 100%;\n  height: 38px !important;\n  padding: 5px 8px;\n}\n\n.custom-select:focus {\n  border-color: transparent;\n}\n\n.banner {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.carousel-container h5 {\n  color: white;\n  text-wrap-mode: nowrap;\n  margin-bottom: 20%;\n  margin-top: 5px;\n}\n\n@media (max-width: 575px) {\n  .login-container {\n    padding: 30px;\n    width: 85%;\n    border: 1px solid #0b3870;\n    left: 50%;\n  }\n\n  .login-sec {\n    padding: 0;\n    background-color: #0b3870;\n  }\n\n  .company-logo {\n    display: none;\n  }\n\n  .banner-sec {\n    display: none;\n  }\n\n  .navbar-brand img {\n    width: 140px;\n    margin-bottom: 30px;\n  }\n\n  .navbar-brand {\n    margin: 0;\n  }\n\n  .navbar {\n    padding: 0;\n  }\n\n  .login-form-container {\n    width: 100%;\n  }\n}\n@media (min-width: 576px) and (max-width: 767px) {\n  .login-container {\n    padding: 30px;\n    width: 85%;\n    border: 1px solid #0b3870;\n  }\n\n  .login-form {\n    padding: 0;\n  }\n\n  .login-sec {\n    padding: 10px 5px 50px 5px;\n  }\n\n  .carousel-container img {\n    width: 70px;\n  }\n  .carcarousel-container h5 {\n    font-size: 1rem;\n  }\n  .navbar-brand img {\n    width: 150px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .login-container {\n    padding: 5px 5px 30px 5px;\n  }\n\n  .login-form {\n    padding: 5px 5px 30px 5px;\n  }\n\n  .login-sec {\n    padding: 10px 5px 50px 5px;\n  }\n\n  .carousel-container h5 {\n    text-wrap-mode: wrap;\n  }\n\n  .login-form-container {\n    left: 0%;\n    width: 83%;\n  }\n}\n\n@media (min-width: 576px) {\n  .mobCompany-logo {\n    display: none;\n  }\n}\n\n.carousel-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  gap: 13%;\n  flex-wrap: wrap;\n}\n\nselect {\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%),\n    linear-gradient(135deg, gray 50%, transparent 50%);\n  background-position: calc(100% - 10px) calc(1em + 2px), calc(100% - 5px) calc(1em + 2px);\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n}\n\nselect:focus {\n  background-image: linear-gradient(45deg, #333 50%, transparent 50%),\n    linear-gradient(135deg, transparent 50%, #333 50%);\n  background-position: calc(100% - 5px) 1em, calc(100% - 10px) 1em;\n  background-size: 5px 5px, 5px 5px;\n  background-repeat: no-repeat;\n  padding: 8px 16px 5px 6px;\n  border-radius: 0.295em;\n  outline: 0;\n}\n\n.carousel-container img {\n  width: 75px;\n  border: 2px solid #fff;\n  padding: 15px;\n}\n/* CSS for New login screen ends here */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
